import MenuItem, { MenuItemProps } from "@material-ui/core/MenuItem";
import { GetItemPropsOptions } from "downshift";
import React, { FunctionComponent } from "react";
import { Suggestion } from "./types";

interface ItemProps {
    itemProps: MenuItemProps;
    suggestion: Suggestion;
    isSelected: boolean;
}

export const Item: FunctionComponent<ItemProps> = ({ suggestion, itemProps, isSelected }) => {
    return (
        <MenuItem
            {...itemProps}
            selected={isSelected}
            component="div"
            style={{
                fontWeight: isSelected ? 500 : 400,
            }}
        >
            {suggestion.label}
        </MenuItem>
    );
};

interface ItemsProps<T> {
    count?: number;
    highlightedIndex: number | null;
    items: Array<T & Suggestion>;
    selectedItem: string;

    getItemProps(options: GetItemPropsOptions<any>): any;
}

// Comparator that does simple sorting based on given suggestion's labels.
const sortByLabel = (a: Suggestion, b: Suggestion): number => (a.label < b.label ? -1 : b.label > a.label ? -1 : 0);

export default function Items<T>({ count, highlightedIndex, items, getItemProps }: ItemsProps<T>) {
    return (
        <>
            {items
                .sort(sortByLabel)
                .slice(0, count || 5)
                .map((suggestion: Suggestion, index: number) => {
                    const isSelected = highlightedIndex === index;
                    return (
                        <Item
                            key={`${suggestion.label} ${index}`}
                            itemProps={getItemProps({ item: suggestion.label })}
                            isSelected={isSelected}
                            suggestion={suggestion}
                        />
                    );
                })}
        </>
    );
}
